<template>
  <div>

    <div class="search-hero">
      <div class="container">

        <h1>{{__('label:home title')}}</h1>

        <div class="row">
          <div class="col-12 col-lg-9">
            <p class="search-hero-helptext">After generating your Course Plan,
              please validate it with the Academic Chair of the Course before enrolling in the units.</p>
            <p>Get started on planning your course.</p>
          </div>
        </div>

        <div class="search-hero-guide">
          <div class="search-hero-guide__step">
            <span class="fal fa-graduation-cap search-hero-guide__step-icon"></span>
            <h3 class="search-hero-guide__step-title">Select your course</h3>
            <p class="search-hero-guide__step-content">Search and select your desired course.</p>
          </div>
          <div class="search-hero-guide__step">
            <span class="fal fa-user search-hero-guide__step-icon"></span>
            <h3 class="search-hero-guide__step-title">Set your preferences</h3>
            <p class="search-hero-guide__step-content">Set your study preferences, study load and start date.</p>
          </div>
          <div class="search-hero-guide__step">
            <span class="fal fa-layer-plus search-hero-guide__step-icon"></span>
            <h3 class="search-hero-guide__step-title">Select your units</h3>
            <p class="search-hero-guide__step-content">Customise your course by adding units, majors, co-majors, and minors.</p>
          </div>
          <div class="search-hero-guide__step">
            <span class="fal fa-calendar search-hero-guide__step-icon"></span>
            <h3 class="search-hero-guide__step-title">Create your course plan</h3>
            <p class="search-hero-guide__step-content">Plan your course across the year and decide when you want to study.</p>
          </div>
        </div>

        <!-- Search on home page feature hidden untill larger whitelist exists... -->
        <!-- <div class="course-search">
          <div class="course-search__label">Start by searching for your course</div>
          <div class="course-search__input-outer">
            <input class="course-search__input" type="text" v-model="searchString" v-on:keyup.enter="setSearch()"
              placeholder="Search by keyword, code or topic" />
            <button class="course-search__btn-clear" type="button" v-if="searchString !== null" v-on:click="clearSearch()">
              <span class="course-search__icon far fa-times"></span>
            </button>
            <select v-model="searchFilterCourseLevel" class="course-search__filter" aria-label="Filter course levels">
              <option value="all">All study levels</option>
              <option v-for="type in courseTypes" v-bind:key="type.id"
                v-bind:value="type.courseloop">
                {{type.label}}
              </option>
            </select>
            <button class="course-search__btn-search" type="button" v-on:click="setSearch()" :disabled="searchString == null">
              <span class="course-search__icon far fa-search"></span>
            </button>
          </div>
        </div> -->

        <a class="search-hero__cta btn btn-primary" href="select-course">Select a course to get started...</a>

      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">
</style>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CourseTypes from 'common/models/course-types.js'

export default {
  props: {
    pageSize: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      searchString: null,
      searchFilterCourseLevel: 'all',
      courseTypes: CourseTypes
    }
  },
  computed: {},
  methods: {
    ...mapGetters({
      getCurrentStepIndex: 'userJourney/getCurrentStepIndex',
      goToSelectCourse: 'userJourney/goToSelectCourse'
    }),
    ...mapMutations({
      setSearchParams: 'courses/setSearchCourseParams'
    }),
    setSearch() {
      if (this.searchString !== null) {
        this.setSearchParams({
          searchString: this.searchString,
          filter: this.searchFilterCourseLevel
        })
        this.goToSelectCourse() // now we have shown the homepage we can enable the real page
      }
    },
    clearSearch() {
      this.searchString = null
      this.setSearchParams({
        searchString: ''
      })
    }
  }
}
</script>

<style>
</style>
